import { Utils, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { BaseController } from "./BaseController";
import { BetManager } from "../../Managers/BetManager";
import { DataManager } from "../../Managers/DataManager";
import { GameManager } from "../../Managers/GameManager";
import { MessageManager } from "../../Managers/MessageManager";
import { FreeRoundBonus } from "../../Channels/Common/Bonuses/FreeRoundBonus";
import { BaseActions } from "../../Channels/Common/Actions/BaseActions";

export class BaseModel {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static GameRequest: GameClientRequest = null;

    protected controller: BaseController;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(controller: BaseController) {
        this.controller = controller;
    }

    //******************************************************************************************************************
    //  REQUESTS
    //******************************************************************************************************************

    public spin(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;

        BaseModel.GameRequest = {} as GameClientRequest;
        BaseModel.GameRequest.module = Communication.Game.GameModules.Base;
        BaseModel.GameRequest.bet = BetManager.createBetForSpin();
        BaseModel.GameRequest.callBackFcn = this.spinReceived.bind(this);

        DataManager.controlAutoplay();
        GameManager.gameClient
            .spin(Communication.Game.GameModules.Base, BetManager.createBetForSpin())
            .then((response: any): any => {
                MessageManager.postpone(this.spinReceived.bind(this), response);
            });
    }

    public static spinContinue(): void {
        if (!GameManager.requestSend && BaseModel.GameRequest) {
            GameManager.requestSend = true;

            GameManager.gameClient
                .spin(BaseModel.GameRequest.module, BaseModel.GameRequest.bet)
                .then((response: any): any => {
                    MessageManager.postpone(BaseModel.GameRequest.callBackFcn, response);
                });

            //after message, we call gameclient spin once again, so we also need to send round started event
            Platforms.Platforms.roundStarted({
                totalBet: BetManager.Bet,
                freeRound: FreeRoundBonus.inFrb,
                userAction: DataManager.getTrustedUserAction(BaseActions.ActionSpin),
            });
        }
    }

    //******************************************************************************************************************
    //  RESPONSES
    //******************************************************************************************************************

    protected spinReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            BaseModel.GameRequest = null;
            this.controller.spinReceived();
            Platforms.Platforms.spinReceived({
                balance: parseFloat(NumberUtils.add(response.balance.real, response.balance.bonus)),
                win: GameManager.baseResponse.currentWin,
                totalBet: BetManager.createBetForSpin().totalBet,
                roundId: response.roundId,
            });
        }

        GameManager.requestSend = false;
    }
}

export type GameClientRequest = {
    module: string;
    bet: Communication.Game.SpinBet;
    callBackFcn: () => void;
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseModel.ts
 **/